import React, { Component } from "react";

import "../components/Shared/Forms/form.css";
import {
  Modal,
  Card,
  CardTitle,
  CardBody,
  CardFooter,
  Button,
} from "reactstrap";

export class WelcomeScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      logo:
        "https://mufasa-qa.interswitchng.com/p/iswportal-v2/uat/apps/VLA/v1_0/static/media//vervelife.png",
    };
  }

  openModal = () => {
    this.setState({
      visible: true,
    });
  };

  closeModal = () => {
    this.setState({
      visible: false,
    });
    this.props.skipTutorialGuide();
  };

  tourApp = () => {
    this.setState({
      visible: false,
    });
    this.props.startTutorialGuide();
  };

  render() {
    const { isFirstTimeUser } = this.props;

    return (
      <section>
        <Modal
          isOpen={isFirstTimeUser ? isFirstTimeUser : this.state.visible}
          toggle={() => this.closeModal()}
          className="welcomeScreen"
          backdrop={"static"}
        >
          <div>
            <Card style={{ textAlign: "center" }}>
              <div>
                <img height="60px" src={this.state.logo} alt="" />
              </div>
              <hr />

              <CardBody>
                <CardTitle>
                  <h2 style={{ fontSize: "19px" }}>
                    Welcome To Verve Life 
                  </h2>{" "}
                </CardTitle>
                <span style={{ fontSize: "15px" }}>
                  Select "TOUR" to start the user guide or select "SKIP" to get
                  started.(Click the red dot to tour the app.)
                </span>
              </CardBody>
              <CardFooter>
                <div className="flexContainer">
                  <Button
                    color="primary "
                    className="flexChld mr-2"
                    onClick={() => this.closeModal()}
                  >
                    SKIP
                  </Button>

                  <Button
                    color="success"
                    onClick={() => this.tourApp()}
                    className="flexChld"
                  >
                    TOUR
                  </Button>
                </div>
              </CardFooter>
            </Card>
          </div>
        </Modal>
      </section>
    );
  }
}

export default WelcomeScreen;
